import data from './custom-generated.json' with { type: 'json' };
export const EMOTES = data;
export const customEmojiCategoriesOrder = [
    'Maskorama',
    'Reaksjoner',
    'Logoer',
    'Egendefinert',
];
export const customCategorySorting = (a, b) => {
    const orderA = customEmojiCategoriesOrder.indexOf(a);
    const orderB = customEmojiCategoriesOrder.indexOf(b);
    if (orderA === -1 && orderB === -1) {
        return a.localeCompare(b);
    }
    if (orderA === -1)
        return 1;
    if (orderB === -1)
        return -1;
    return orderA - orderB;
};
//# sourceMappingURL=custom.js.map